import { openDB } from 'idb';
import { fileTypeFromBuffer } from 'file-type';
import axiosInstance from './axiosInstance';

const DB_NAME = process.env.REACT_APP_IDB_NAME !== undefined ? process.env.REACT_APP_IDB_NAME : 'adjure';
const STORE_NAME = process.env.REACT_APP_IDB_STORE_NAME !== undefined ? process.env.REACT_APP_IDB_STORE_NAME : 'case-record-images';

const initIDB = async () => {
  return openDB(DB_NAME, 1, {
    upgrade(db) {
      if (!db.objectStoreNames.contains(STORE_NAME)) {
        db.createObjectStore(STORE_NAME);
      }
    },
  });
};

const setItem = async (key: any, value: any) => {
  const db = await initIDB();
  const tx = db.transaction(STORE_NAME, 'readwrite');
  const store = tx.objectStore(STORE_NAME);
  await store.put(value, key);
  await tx.done;
};

const getItem = async (key: any) => {
  const db = await initIDB();
  const tx = db.transaction(STORE_NAME, 'readonly');
  const store = tx.objectStore(STORE_NAME);
  const item = await store.get(key);
  await tx.done;
  return item;
};

export const clearIDB = async () => {
  const db = await initIDB();
  const tx = db.transaction(STORE_NAME, 'readwrite');
  const store = tx.objectStore(STORE_NAME);
  await store.clear();
  await tx.done;
};

window.addEventListener('unload', async () => {
  await clearIDB();
});

export function strtr(str: any, replacePairs: any) {
  if (!str) return str;
  return Object.keys(replacePairs).reduce((acc, key) => {
    const regex = new RegExp(key, "gi");
    return acc.replace(regex, replacePairs[key]);
  }, str);
}

async function generateBlobImages(byteImagesArr: any) {
  let blobImagesArr: any = {};
  const promises = Object.entries(byteImagesArr).map(async ([imageGUID, byteImage]) => {
    const type = await fileTypeFromBuffer(byteImage as ArrayBuffer);
    const blob = new Blob([byteImage as BlobPart], { type: type?.mime || 'image/jpeg' });
    blobImagesArr[imageGUID.toLowerCase()] = window.URL.createObjectURL(blob);
  });
  await Promise.all(promises);
  return blobImagesArr;
}

export default function downloadImagesAndReplace(images: any, description: any): Promise<any> {
  return new Promise((resolve, reject) => {
    let imagesLength = images.length;
    let imageContentsLength = 0;
    let byteImagesArr: any = {};
    images.map(async (image: any) => {
      const byteImage = await getItem(image.imageGUID.toLowerCase());
      if (byteImage) {
        byteImagesArr[image.imageGUID.toLowerCase()] = byteImage;
        imageContentsLength++;
        if (imageContentsLength === imagesLength) {
          const blobImagesArr = await generateBlobImages(byteImagesArr);
          resolve({
            description: strtr(description, blobImagesArr),
            blobImagesArr,
          });
        }
      } else {
        await axiosInstance.get(image.downloadsUrl, { responseType: 'arraybuffer' }).then(async ({ data, status }) => {
          imageContentsLength++;
          if (status === 200) {
            byteImagesArr[image.imageGUID.toLowerCase()] = data;
            await setItem(image.imageGUID.toLowerCase(), data);
            if (imageContentsLength === imagesLength) {
              const blobImagesArr = await generateBlobImages(byteImagesArr);
              resolve({
                description: strtr(description, blobImagesArr),
                blobImagesArr,
              });
            }
          }
        })
          .catch((error) => {
            imageContentsLength++;
            console.log(error);
          });
      }
    });
  });
}